import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchProductSubgroups } from '../../../../actions/product/productSubgroupList'
import { AppState } from '../../../../reducers'
import { FiltersBar, FilterTextField } from '../../../Utils/Filters/Filter'
import { useTranslation } from 'react-i18next'
import { ProductSubgroupListState } from '../../../../reducers/product/productSubgroupList'
import { Button, Stack } from '@mui/material'
import ProductSubgroup from '../../../../models/ProductSubgroup'
import ProductSubgroups from '../ProductSubgroups'

interface Props {
  fullInfo?: boolean
  productSubgroupList: ProductSubgroupListState
}

const ProductSubgroupList: React.FC<Props> = ({ productSubgroupList }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('product')
  const [edit,] = useState(false)

  useEffect(() => {
    dispatch(fetchProductSubgroups(history.location.search))
  }, [dispatch, history.location.search, edit])


  const linkToProductSubgroupEdit = (productSubgroup: ProductSubgroup) => {
    const editUrl = `/admin/productSubgroups/update/${productSubgroup.id}`
    history.push(editUrl, { update: edit })
  }

  return (
    <div>
      <FiltersBar>
        <FilterTextField style={{marginRight:"10px"}} name="code" label={t("code")} />
        <FilterTextField style={{maxWidth:"400px", width:"400px", marginRight:"10px"}} name="description" label={t("description")} />
      </FiltersBar>
      <ProductSubgroups
        rows={(productSubgroupList.productSubgroups || []).map(s => ({ data: s }))}
        loading={productSubgroupList.isFetching}
        pagination={productSubgroupList.pagination || undefined}
        onClickInfo={linkToProductSubgroupEdit}
      />

      <Stack display="flex" flexDirection='row' justifyContent="space-between" padding="10px">
        <Button aria-label="back" size='large' style={{ textTransform: 'none' }}  onClick={() => history.push('/admin/productSubgroups/create', { title: t('create') })}>
          {`${t('create')}${t('subgroup')}`}
        </Button>
      </Stack>
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  productSubgroupList: state.productSubgroupList,
})

export default connect(mapStateToProps, null)(ProductSubgroupList)